module.exports = __webpack_public_path__ + "assets/img/list_sukikamo_white.8cc90bea.svg";